import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { headers, filters } from "./config";

const VendorList = () => {

  return (
    <Table tableId="vendors" title="Vendor" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="brand_name" idKey="vendor_id" fieldsToSearch={["Name", "Email", "Phone"]} />
  );
};

export default VendorList;